import { useLinkBuilder as useNativeLinkBuilder } from '@react-navigation/native';

const useLinkBuilder: UseLinkBuilder = useNativeLinkBuilder as any;

export default useLinkBuilder;

type UseLinkBuilder = <ParamList extends Record<string, object | undefined>>() => <RouteName extends keyof ParamList>(
  name: RouteName,
  params?: ParamList[RouteName],
) => string;
